import i18next from 'i18next';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import {
  fetchOwnPetProgressComparison,
  fetchOwnPetProgressSeries,
  fetchPatientProgressComparison,
  fetchPatientProgressSeries,
} from '@/api/progress/progressApi';
import type {
  ProgressComparisonEntry,
  ProgressMetricSeries,
} from '@/api/progress/progressApi.types';
import {
  buildOwnPetProgressQueryKey,
  buildPatientProgressComparisonQueryKey,
  buildPatientProgressSeriesQueryKey,
} from '@/constants/queryKeys';

export function usePatientProgressSeriesQuery(
  patientId: string
): UseQueryResult<ProgressMetricSeries[], Error> {
  return useQuery({
    queryKey: [...buildPatientProgressSeriesQueryKey(patientId), i18next.language],
    queryFn: function loadSeries() {
      return fetchPatientProgressSeries(patientId);
    },
    enabled: patientId.length > 0,
  });
}

export function usePatientProgressComparisonQuery(
  patientId: string
): UseQueryResult<ProgressComparisonEntry[], Error> {
  return useQuery({
    queryKey: [...buildPatientProgressComparisonQueryKey(patientId), i18next.language],
    queryFn: function loadComparison() {
      return fetchPatientProgressComparison(patientId);
    },
    enabled: patientId.length > 0,
  });
}

export function useOwnPetProgressSeriesQuery(
  patientId: string
): UseQueryResult<ProgressMetricSeries[], Error> {
  return useQuery({
    queryKey: [...buildOwnPetProgressQueryKey(patientId), 'series', i18next.language],
    queryFn: function loadSeries() {
      return fetchOwnPetProgressSeries(patientId);
    },
    enabled: patientId.length > 0,
  });
}

export function useOwnPetProgressComparisonQuery(
  patientId: string
): UseQueryResult<ProgressComparisonEntry[], Error> {
  return useQuery({
    queryKey: [...buildOwnPetProgressQueryKey(patientId), 'comparison', i18next.language],
    queryFn: function loadComparison() {
      return fetchOwnPetProgressComparison(patientId);
    },
    enabled: patientId.length > 0,
  });
}
